import { render } from "./PersonalStatisticsPage.vue?vue&type=template&id=daefa54c&scoped=true"
import script from "./PersonalStatisticsPage.vue?vue&type=script&lang=js"
export * from "./PersonalStatisticsPage.vue?vue&type=script&lang=js"

import "./PersonalStatisticsPage.vue?vue&type=style&index=0&id=daefa54c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daefa54c"]])

export default __exports__